import { useEffect } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from "@albo-ui/core";
import { IconButton, TextField } from "@mui/material";
import { useInsertLink } from "./hooks/useInsertLink";
import { AttachFile } from "@mui/icons-material";
import { Skeleton } from '@albo-ui/core'

export const CompanyInsertLink = ({ changeAlert, onConfirm, onClose, open, title, data }: any) => {
    const { form, error, loading, fileName, isValidForm, updateProps, onHandleChange, onSelectFile } = useInsertLink(open, changeAlert, data);

    const onHandleConfirm = () => {
        let f = form;
        Object.keys(f).map((i) => {
            if(updateProps.indexOf(i) === -1){
                delete f[i]
            }
            return f;
        })
        return onConfirm({company: f});
    };
    const addFile = () => {
        document.getElementById('file').click();  
    };

    useEffect(() => {}, [loading])

    return (
        <Dialog open={open} onClose={onClose} >
            <DialogTitle>
                <Typography variant="h2">{title}</Typography>
            </DialogTitle>
            {loading ? 
                <Skeleton width='100%' height='100px' style={{marginTop: 20}} />
                :  
                <DialogContent style={{ paddingTop: 30 }}>
                    <FlexGrid container direction="column" alignItems='flex-start' spacing={2}>
                        <FlexGrid container spacing={2} fullWidth>
                            <TextField value={form["corporate_name"] || ""} onInput={onHandleChange.bind(this, "corporate_name")} label="Nombre de la empresa" error={error['corporate_name'] ? true : false} helperText={error['corporate_name']} color="secondary" fullWidth/>
                        </FlexGrid>
                        <FlexGrid container spacing={2} fullWidth>
                            <TextField value={form["company_id"] || ""} onInput={onHandleChange.bind(this, "company_id")} label="URL ID" error={error['company_id'] ? true : false} helperText={error['company_id']} color="secondary" fullWidth/>
                        </FlexGrid>

                        <FlexGrid container spacing={2} fullWidth alignItems="center">
                            <IconButton onClick={addFile.bind(this, "")} sx={{padding: "0 !important"}} >
                                <AttachFile titleAccess="Adjuntar imagen" sx={{padding: "7px", borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#8bc179" }} />
                                <input type="file" accept=".png, .jpeg, .jpg" style={{display: 'none'}} id="file" onChange={onSelectFile.bind(this)} />
                            </IconButton>
                            <Typography variant="paragraph" style={{fontSize: 16}}>{(fileName || (data ? "Cambiar " : "Adjuntar ") + "Logo de la Empresa")}</Typography>
                        </FlexGrid>
                        {error['logo_url'] && <Typography color={"required"} variant="paragraph" >{error['logo_url']}</Typography>}
                    </FlexGrid>
                </DialogContent>
            }

            <DialogActions>
                <FlexGrid fullHeight fullWidth justify="space-between" alignItems="space-between" style={{ marginTop: "20px", display: "flex" }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType="secondary" size="normal">
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item style={{ textAlign: "end" }}>
                        <Button onClick={() => onHandleConfirm()} disabled={isValidForm} size="normal">
                            Aceptar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};
